import React, {useEffect, useState} from 'react'
import Button from "../components/Button";
import TraccoLogo from "../images/Tracco Logo.webp";

import BacktoTopButton from "../components/BackToTop";

export const TemporaryHeader = () => {

  return (
    <div>
      {/* Header */}
      <header
        className="bg-header-img bg-no-repeat bg-cover bg-center bg-fixed"
        id="header"
      >
        <BacktoTopButton />

        {/* Header Text */}
        <div className="container mx-auto flex justify-center items-center content-center flex-col h-screen text-white">
          <div className=" bg-white rounded-3xl flex justify-center items-center content-center flex-col mx-4 py-10 lg::mx-20 lg:mx-52 px-4">
            
            {/* Logo */}
            <a
              href="/"
              className="flex items-center justify-center px-4 pb-10"
              rel="noreferrer"
            >
              <img src={TraccoLogo} alt="Tracco Logo" className="w-10" />
              <p className="text-2xl ml-3 text-black font-bold inline-block">
                Tracco
              </p>
            </a>
          <div className="lg:w-60 lg:h-60 w-48 h-48 mb-4">
            <lottie-player src="https://assets8.lottiefiles.com/private_files/lf30_yh8elhgn.json" loop autoplay></lottie-player>
          </div>
          <h1 className="md:text-[48px] font-bold lg:leading-[120%] md:leading-[124%] text-[32px] leading-[124%] z-10 text-black">
            Under Construction ⚙️
          </h1>
          <p className="text-slate-600 md:text-lg text-base pt-2 pb-6 lg:px-20 md:px-10 z-10">
          We're currently working on our website, but in the meantime, feel free to check out our temporary web version below 👇
          </p>
          {/* Button */}
          <Button name="Visit Website" link="https://tracco.typedream.app/" />
          </div>
        </div>
      </header>
    </div>
  );
};

export default TemporaryHeader;
